import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function CircularIndeterminate( {title = 'No critical or immediate problems to resolve', text = "Loading Data, Please Wait...", charged}) {


  return (
    <Box sx={{ display: 'flex' }}>
      {!charged ? (
        <Box sx={{justifyContent: 'center', alignItems:'center', display: "flex", gap: 2 }}>
        <Typography variant='h4' style={{color: '#eaeaea'}}><CircularProgress style={{ color: '#eaeaea' }} /></Typography><Typography variant='h4' style={{color: '#eaeaea', fontSize: 15, fontWeight: 600}}>{text}</Typography>
        </Box>
      ) : (
        <Box sx={{justifyContent: 'center', alignContent:'center' }}>
        <Typography variant='h4' style={{color: '#eaeaea'}}><CheckCircleIcon />  {title}</Typography>
        </Box>
      )}
    </Box>
  );
}
